import React from 'react'
import { ContactBody, ContactHero } from './Layout'
import { Footer, Header } from '../../../Components'

export default function Contact() {
  return (
    <main>
      <Header />
      <ContactHero />
      <ContactBody />
      <Footer />
    </main>
  )
}
